import React from 'react';
import { withTranslation } from 'react-i18next';

import { CollapseView } from '../CollapseView';
import { StripesView } from '../StripesView';
import { Tabs } from '../Tabs';
import { Tab } from '../Tab';
import { connect } from 'react-redux';
import { BasicView } from '../BasicView';

class Content extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { settings, isNoCategories, arr } = this.props;
    return (
      <>
        {isNoCategories ? (
          <>
            {((settings.isBasic && settings.isDisplayCategoriesTop) ||
              settings.isCollapse ||
              settings.isStripes) && (
              <>
                {settings.isBasic && settings.isDisplayCategoriesTop && (
                  <div
                    className="basic-view"
                    // id={`basicItem_${catItem.id}`}
                  >
                    <BasicView
                      className="question-basic-view"
                      questions={arr.flat(1)}
                    />
                  </div>
                )}

                {settings.isStripes && (
                  <div
                    className="stripes-view margin-bottom30"
                    role="list"
                    // id={`stripItem_${catItem.id}`}
                  >
                    <StripesView
                      className="question-stripes-view"
                      questions={arr.flat(1)}
                    />
                  </div>
                )}
                {settings.isCollapse && (
                  <div
                    className="collapse-view margin-bottom30"
                    role="list"
                    // id={`collapseItem_${catItem.id}`}
                  >
                    <div id="accordion">
                      <CollapseView questions={arr.flat(1)} />
                    </div>
                  </div>
                )}
              </>
            )}
          </>
        ) : (
          <Tabs layout={settings.layout}>
            {arr.map((catItem, index) => {
              return (
                <Tab
                  title={catItem.title}
                  key={`tab_key_${catItem.id}`}
                  id={`tab${index}`}
                >
                  {settings.isBasic && settings.isDisplayCategoriesTop && (
                    <div className="basic-view" id={`basicItem_${catItem.id}`}>
                      <BasicView
                        className="question-basic-view"
                        questions={catItem.questionsList}
                      />
                    </div>
                  )}

                  {settings.isStripes && (
                    <div
                      className="stripes-view margin-bottom30"
                      id={`stripItem_${catItem.id}`}
                      role="list"
                    >
                      <StripesView
                        className="question-stripes-view"
                        questions={catItem.questionsList}
                      />
                    </div>
                  )}
                  {settings.isCollapse && (
                    <div
                      className="collapse-view margin-bottom30"
                      id={`collapseItem_${catItem.id}`}
                    >
                      <div id="accordion">
                        <CollapseView questions={catItem.questionsList} />
                      </div>
                    </div>
                  )}
                </Tab>
              );
            })}
          </Tabs>
        )}
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    ...state,
  };
}

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(Content));
